
import { isAlphaNumeric, isLength, isSpecialChar, isPhoneNumber, isNameLength, isVerifyCode, isPassword, isPasswordsMatch, isEmpty } from '@/util/verify.js'

// 校验映射表
export const validationFunctions = {
    isAlphaNumeric: (value, rule) => isAlphaNumeric(value),
    isLength: (value, rule) => isLength(value, rule.min, rule.max),
    isSpecialChar: (value, rule) => isSpecialChar(value),
    isPhoneNumber: (value, rule) => isPhoneNumber(value),
    isNameLength: (value, rule) => isNameLength(value, rule.min, rule.max),
    isVerifyCode: (value, rule) => isVerifyCode(value),
    isPassword: (value, rule) => isPassword(value),
    isPasswordsMatch: (value, rule) => isPasswordsMatch(value, rule.strone, rule.strtwo),
    isEmpty: (value, rule) => isEmpty(value),
};


// WEBPACK FOOTER //
// ./src/util/verifyMap.js